import { render, staticRenderFns } from "./KeyValuesEdit.vue?vue&type=template&id=4df009a9"
import script from "./KeyValuesEdit.vue?vue&type=script&lang=js"
export * from "./KeyValuesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports